import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ApiEndpoints } from "../../../helper/ApiEndpoints";
import ApiRequest from "../../../helper/ApiRequest";
import CustomSelect from "../../../component/CustomSelect";
import CustomImageUpload from "../../../component/CustomImageUpload";
import DynamicCKEditor from "../../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../../component/AdminHeader";
import { Link } from "react-router-dom";
import { BaseUrl } from "../../../helper/BaseUrl";

const updateEndpoint = ApiEndpoints.case.Update;
const editEndpoint = ApiEndpoints.case.Edit;
const industryListEndpoint = ApiEndpoints.industry.List;
const authorListEndpoint = ApiEndpoints.autor.authorList;
const userName = !localStorage.getItem("username") ? "Admin" : localStorage.getItem("username");

export default function EditCase() {
  const navigate = useNavigate();
  const { case_id } = useParams();

  const [industries, setIndustries] = useState([]);
  const [authors, setAuthors] = useState([]);

  const [previews, setPreviews] = useState({ thumbnail: null, logo: null, banner_image: null, key_solution_highlights_image: null, });

  const [postData, setPostData] = useState({ industry_id: "", author_id: "", region: "", title: "", slug: "", thumbnail: null, logo: null, stat1_count: "", stat1_title: "", stat2_count: "", stat2_title: "", stat3_count: "", stat3_title: "", banner_image: null, introduction_content: "", about_content: "", challenges_content: "", quote: "", market_opportunity_subheading1: "", market_opportunity_subheading1_description: "", market_opportunity_subheading2: "", market_opportunity_subheading2_description: "", solution_content: "", key_solution_highlights_content: "", key_solution_highlights_image: null, results_content: "", date: new Date(), video:""});

  const regionData = [
    { _id: "middle-east", name: "Middle East" },
    { _id: "america", name: "America" },
    { _id: "africa", name: "Africa" },
    { _id: "uk-and-europe", name: "UK & Europe" },
    { _id: "apac", name: "APAC" },
  ]

  useEffect(() => {

    const fetchData = async () => {
      try {
        const response = await ApiRequest("GET", editEndpoint + case_id);
        setPostData(response?.casestudy || {});
        setAuthors(response?.authors || []);
        setIndustries(response?.industries || []);

        setPreviews({
        thumbnail: response?.casestudy.thumbnail ? BaseUrl + response?.casestudy.thumbnail : null,
        logo: response?.casestudy.logo ? BaseUrl + response?.casestudy.logo : null,
        banner_image: response?.casestudy.banner_image ? BaseUrl + response?.casestudy.banner_image : null,
        key_solution_highlights_image: response?.casestudy.key_solution_highlights_image  ? BaseUrl + response?.casestudy.key_solution_highlights_image : null,
      });


      } catch (error) {
        console.error("Failed to fetch industries:", error);
        setIndustries([]);
      }
    };

    fetchData();

  }, [case_id]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      const file = files[0];
      // Update the previews state
      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(file),
      }));

      // Update the postData state
      setPostData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      // For non-file inputs, update the postData state directly
      setPostData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleEditorChange = (key, data) => {
    setPostData((prevState) => ({
      ...prevState,
      [key]: data,
    }));
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const [key, value] of Object.entries(postData)) {
      if (key !== "video" && (value === "" || value === null)) {
        toast.error(`The field "${key}" is mandatory.`);
        return;
      }
    }

    const formData = new FormData();
    Object.entries(postData).forEach(([key, value]) => {
      formData.append(key, value);
    });

    try {
      const response = await ApiRequest("POST", updateEndpoint + case_id, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success(response.message);
      navigate("/case-study");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const pagename = {
    name: 'Case Study Management',
    user: 'Admin',
    innerpage: 'Case Study Management / Case Study / Edit Case Study'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-content-page">
        <form id="caseEdit" onSubmit={handleSubmit}>

          <div className="add-content-wrap">
            <div className="row">

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>title<small>*</small></label>
                  </div>
                  <input value={postData?.title} onChange={handleChange} name="title" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>slug<small>*</small></label>
                  </div>
                  <input value={postData?.slug} onChange={handleChange} name="slug" type="text" className="form-control" placeholder="Enter Slug" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Date<small>*</small></label>
                  </div>
                  <input value={ postData.date ? new Date(postData.date).toISOString().split("T")[0]: "" } onChange={handleChange} name="date" type="date" className="form-control" placeholder="Enter Author Name" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Video Url<small></small></label>
                  </div>
                  <input value={postData?.video} onChange={handleChange} name="video" type="text" className="form-control" placeholder="Enter Video Url" />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>industry<small>*</small></label>
                  </div>
                  <CustomSelect defaultValue={postData?.industry_id} onChange={handleChange} name={"industry_id"} options={industries} placeholder="Select Industry" />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Author Name<small>*</small></label>
                  </div>
                  <CustomSelect defaultValue={postData?.author_id} onChange={handleChange} name="author_id" options={authors} placeholder="Select Author Name" />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Region<small>*</small></label>
                  </div>
                  <CustomSelect defaultValue={postData?.region} onChange={handleChange} name="region" options={regionData} placeholder="Select Region Name" />
                </div>
              </div>

            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <h5>Listing Page Area</h5>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Stat 1 Count<small>*</small></label>
                  </div>
                  <input value={postData?.stat1_count} onChange={handleChange} name="stat1_count" type="text" className="form-control" placeholder="Enter Stat 1 Count" />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Stat 1 Title<small>*</small></label>
                  </div>
                  <input value={postData?.stat1_title} onChange={handleChange} name="stat1_title" type="text" className="form-control" placeholder="Enter Stat 1 Title" />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Stat 2 Count<small>*</small></label>
                  </div>
                  <input value={postData?.stat2_count} onChange={handleChange} name="stat2_count" type="text" className="form-control" placeholder="Enter Stat 2 Count" />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Stat 2 Title<small>*</small></label>
                  </div>
                  <input value={postData?.stat2_title} onChange={handleChange} name="stat2_title" type="text" className="form-control" placeholder="Enter Stat 2 Title" />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Stat 3 Count<small>*</small></label>
                  </div>
                  <input value={postData?.stat3_count} onChange={handleChange} name="stat3_count" type="text" className="form-control" placeholder="Enter Stat 3 Count" />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Stat 3 Title<small>*</small></label>
                  </div>
                  <input value={postData?.stat3_title} onChange={handleChange} name="stat3_title" type="text" className="form-control" placeholder="Enter Stat 3 Title" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Thumbnail Image (1608 x 640 Px)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="thumbnail"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.thumbnail}
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Client Logo (208 x 69 Px)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="logo"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.logo}
                  />
                </div>
              </div>

            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <h5>Detail Page Area</h5>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>introduction content<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.introduction_content} onChange={(event, editor) => handleEditorChange("introduction_content", editor?.getData())} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>about content<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.about_content} onChange={(event, editor) => handleEditorChange("about_content", editor?.getData())} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>challenges content<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.challenges_content} onChange={(event, editor) => handleEditorChange("challenges_content", editor?.getData())} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>quote content<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.quote} onChange={(event, editor) => handleEditorChange("quote", editor?.getData())} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>market opportunity subheading 1<small>*</small></label>
                  </div>
                  <input value={postData?.market_opportunity_subheading1} onChange={handleChange} name="market_opportunity_subheading1" type="text" className="form-control" placeholder="Enter Subheading 1" />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>market opportunity Description 1<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.market_opportunity_subheading1_description} onChange={(event, editor) => handleEditorChange("market_opportunity_subheading1_description", editor?.getData())} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>market opportunity subheading 2<small>*</small></label>
                  </div>
                  <input value={postData?.market_opportunity_subheading2} onChange={handleChange} name="market_opportunity_subheading2" type="text" className="form-control" placeholder="Enter Subheading 2" />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>market opportunity Description 2<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.market_opportunity_subheading2_description} onChange={(event, editor) => handleEditorChange("market_opportunity_subheading2_description", editor?.getData())} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>solution content<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.solution_content} onChange={(event, editor) => handleEditorChange("solution_content", editor?.getData())} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Key solution highlights<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.key_solution_highlights_content} onChange={(event, editor) => handleEditorChange("key_solution_highlights_content", editor?.getData())} />
                </div>
              </div>

              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>results content<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.results_content} onChange={(event, editor) => handleEditorChange("results_content", editor?.getData())} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>banner Image (1608 x 680 Px)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="banner_image"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.banner_image}
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Key Solution Image (518 x 450 Px)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="key_solution_highlights_image"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.key_solution_highlights_image}
                  />
                </div>
              </div>

            </div>
          </div>

        </form>

        <button type="submit" form="caseEdit" className="default-btn">publish <span></span></button>
      </div>
    </>
  );
}
